import axios from 'axios';
import {req, reqJson} from './axiosFun';

/**
 * 首页图片管理
 **/
//图片列表
export const imageList = () => { return reqJson("get", "/api/business/image/list") };
//新增首页图片
export const imageSave = (params) => { return reqJson("post", "/api/business/image/add", params) };
//删除首页图片
export const imageDel = (params) => { return reqJson("get", "/api/business/image/deleteByUrl/"+params,params) };





// WEBPACK FOOTER //
// ./src/api/imageMg.js